import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { successCallStatusListFunc } from "../redux-store/actions";
import CloseIcon from "@material-ui/icons/Close";
import "./Filterbar.css";
import { act } from "@testing-library/react";
import { statusListCallHistoryFunc } from "../redux-store/actions";
import { set } from "date-fns";
import styled from "styled-components";
import { API_URL } from "../ConstVariable";
import { useAuth0 } from "@auth0/auth0-react";

const ActiveStateContainer = styled.div`
  display: flex;
  justify-items: center;
  margin-bottom: 10px;
  width: 250px;
`;

const ActiveStateInputContainer = styled.div`
  display: flex;
  align-items: center;
`;
const SuccessfulTextContainer = styled.div`
  margin-right: 15px;
  border-bottom: 1px solid blue;
  font-size: 16px;
`;
const TextWrapper = styled.div`
  display: flex;
  color: blue;
  cursor: pointer;
  position: absolute;
  top: 281px;
  left: 6px;
`;
const UnSelectText = styled.div`
  margin-right: 15px;
  border-bottom: 1px solid blue;
  font-size: 16px;
`;

const StatusCodeList = ({
  closeModal,
  showCallStatus,
  setShowCallStatus,
  resetClick,
  selectedCallStatusHandler,
  selectedCallStatus,
  onData
  
}) => {
  const [statusCodes, setStatusCodes] = useState({
    successFulActive: [],
    successFulUnActive: [],
    userDisconnectActive: [],
    userDisconnectUnActive: [],
    aiEscalationActive: [],
    aiEscalationUnActive: [],
  });
  const { getAccessTokenSilently } = useAuth0();
  const GetAuthToken = async () => {
    const token = await getAccessTokenSilently();
    return token;
};
  const selectedStatusRef = useRef({
    selectedStatusList: [],
  });

  const successFullStatusCodeList = [1001, 1002, 1004, 2004, 3007];


 

  const state = useSelector((state) => state);

  const getCenterListAndCallStatus = async () => {
    try {
      const token = await GetAuthToken();

      if (true) {
        await fetch(
          API_URL + "/oi/api/v1/operator-feedback-status-and-centers",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            credentials: "include"
          }
        )
          .then((response) => response.json())
          .then((data) => {
            let call_status_list = data?.call_status_list;
            onData(data);
            let AI_CALL = null;
            let USER_DISCONNECT = null;
            let AI_ESCALATE = null;
            if (call_status_list) {
              AI_CALL = call_status_list.filter((item) => {
                return (
                  item.operator_feedback.toString().substring(0, 3) == "100"
                );
              });

              //NOTE:- Adding a new key isChecked
              for (let i = 0; i < AI_CALL.length; i++) {
                AI_CALL[i]["isChecked"] = false;
              }
            }
            if (call_status_list) {
              USER_DISCONNECT = call_status_list.filter((item) => {
                return (
                  item.operator_feedback.toString().substring(0, 3) == "200"
                );
              });
              for (let i = 0; i < USER_DISCONNECT.length; i++) {
                USER_DISCONNECT[i]["isChecked"] = false;
              }
            }
            if (call_status_list) {
              AI_ESCALATE = call_status_list.filter((item) => {
                return (
                  item.operator_feedback.toString().substring(0, 3) == "300"
                );
              });
              for (let i = 0; i < AI_ESCALATE.length; i++) {
                AI_ESCALATE[i]["isChecked"] = false;
              }
            }

            let ActiveAIStatus = null;
            let NotActiveAIStatus = null;
            let ActiveUserDisconnectStatus = null;
            let NotActiveUserDisconnectStatus = null;
            let ActiveAiEscalate = null;
            let NotActiveAiEscalate = null;
            if (AI_CALL !== null) {
              ActiveAIStatus = AI_CALL.filter((item) => item.is_active == 1);
              NotActiveAIStatus = AI_CALL.filter((item) => item.is_active == 0);
            }
            if (USER_DISCONNECT !== null) {
              ActiveUserDisconnectStatus = USER_DISCONNECT.filter(
                (item) => item.is_active == 1
              );
              NotActiveUserDisconnectStatus = USER_DISCONNECT.filter(
                (item) => item.is_active == 0
              );
              // console.log("NotActiveUserDisconnectStatus", NotActiveUserDisconnectStatus);
            }

            if (AI_ESCALATE !== null) {
              ActiveAiEscalate = AI_ESCALATE.filter(
                (item) => item.is_active == 1
              );
              NotActiveAiEscalate = AI_ESCALATE.filter(
                (item) => item.is_active == 0
              );
              // console.log("NotActiveAiEscalate", NotActiveAiEscalate);
            }

            setStatusCodes((prevState) => {
              return {
                ...prevState,
                successFulActive: ActiveAIStatus ? ActiveAIStatus : [],
                successFulUnActive: NotActiveAIStatus ? NotActiveAIStatus : [],
                userDisconnectActive: ActiveUserDisconnectStatus
                  ? ActiveUserDisconnectStatus
                  : [],
                userDisconnectUnActive: NotActiveUserDisconnectStatus
                  ? NotActiveUserDisconnectStatus
                  : [],
                aiEscalationActive: ActiveAiEscalate ? ActiveAiEscalate : [],
                aiEscalationUnActive: NotActiveAiEscalate
                  ? NotActiveAiEscalate
                  : [],
              };
            });
          });
      }
    } catch (error) {
      // SetErrorForDisplay({ severity: "warning", message: error.message });
    }
  };

  useEffect(() => {
    getCenterListAndCallStatus();
  }, []);

  let modalRef = null;
  const handleClose = (e) => {
    if (modalRef && !modalRef.contains(e.target)) {
      closeModal();
    }
  };
  const [showStatusList, setShowStatusList] = useState(true);

  const [selectedStatus, setSelectedStatus] = useState([]);
  useEffect(() => {
    setSelectedStatus([]);
  }, [resetClick]);

  // console.log("Initial selectedStatus", selectedStatus);
  let slectedStatusCodeArray = [];
  const [rerenderStatusList, setRerenderStatusList] = useState(false);

  const showStatusListToggle = () => {
    setShowStatusList(!showStatusList);
  };
  const dispatch = useDispatch();

  // Handling AI Successful status
  const successFulStatusHandler = (feedback, option) => {
    let successFulActive = statusCodes?.successFulActive;
    let selectedStatusCode = selectedStatusRef?.current.selectedStatusList;
    let idx = successFulActive.findIndex(
      (item) => item.operator_feedback === feedback
    );
    let data = successFulActive[idx];
    if (successFulActive[idx].isChecked) {
      data = {
        ...data,
        isChecked: false,
      };
      selectedStatusCode = selectedStatusCode.filter(
        (statusCode) => statusCode != feedback
      );
    } else {
      data = {
        ...data,
        isChecked: true,
      };
      selectedStatusCode.push(feedback);
    }
    successFulActive[idx] = data;
    setStatusCodes((prevState) => {
      return {
        ...prevState,
        successFulActive: successFulActive,
      };
    });
    selectedStatusRef.current.selectedStatusList = selectedStatusCode;
    selectedCallStatusHandler(()=>selectedStatusCode)
   
  };

  // Successful UnActive Status code handler
  const successFulUnActiveStatusHandler = (feedback, option) => {
    let successFulUnActive = statusCodes?.successFulUnActive;
    let selectedStatusCode = selectedStatusRef?.current.selectedStatusList;

    let idx = successFulUnActive.findIndex(
      (item) => item.operator_feedback === feedback
    );
    let data = successFulUnActive[idx];
    if (successFulUnActive[idx].isChecked) {
      data = {
        ...data,
        isChecked: false,
      };
      selectedStatusCode = selectedStatusCode.filter(
        (statusCode) => statusCode != feedback
      );
    } else {
      data = {
        ...data,
        isChecked: true,
      };
      selectedStatusCode.push(feedback);
    }
    successFulUnActive[idx] = data;
    setStatusCodes((prevState) => {
      return {
        ...prevState,
        successFulUnActive: successFulUnActive,
      };
    });
    selectedStatusRef.current.selectedStatusList = selectedStatusCode;
    selectedCallStatusHandler(()=>selectedStatusCode)

  };

  // UserDisconnect Status Handler
  const userDisconnectStatusHandler = (feedback, option) => {
    let userDisconnectActive = statusCodes?.userDisconnectActive;
    let selectedStatusCode = selectedStatusRef?.current.selectedStatusList;

    let idx = userDisconnectActive.findIndex(
      (item) => item.operator_feedback === feedback
    );
    let data = userDisconnectActive[idx];
    if (userDisconnectActive[idx].isChecked) {
      data = {
        ...data,
        isChecked: false,
      };
      selectedStatusCode = selectedStatusCode.filter(
        (statusCode) => statusCode != feedback
      );
    } else {
      data = {
        ...data,
        isChecked: true,
      };
      selectedStatusCode.push(feedback);
    }
    userDisconnectActive[idx] = data;
    setStatusCodes((prevState) => {
      return {
        ...prevState,
        userDisconnectActive: userDisconnectActive,
      };
    });
    selectedStatusRef.current.selectedStatusList = selectedStatusCode;
    selectedCallStatusHandler(()=>selectedStatusCode)

  };

  // User Disconnect Unactive status Handler
  const userDisconnectUnActiveStatusHandler = (feedback, option) => {
    let userDisconnectUnActive = statusCodes?.userDisconnectUnActive;
    let selectedStatusCode = selectedStatusRef?.current.selectedStatusList;

    let idx = userDisconnectUnActive.findIndex(
      (item) => item.operator_feedback === feedback
    );
    let data = userDisconnectUnActive[idx];
    if (userDisconnectUnActive[idx].isChecked) {
      data = {
        ...data,
        isChecked: false,
      };
      selectedStatusCode = selectedStatusCode.filter(
        (statusCode) => statusCode != feedback
      );
    } else {
      data = {
        ...data,
        isChecked: true,
      };
      selectedStatusCode.push(feedback);
    }
    userDisconnectUnActive[idx] = data;
    setStatusCodes((prevState) => {
      return {
        ...prevState,
        userDisconnectUnActive: userDisconnectUnActive,
      };
    });
    selectedStatusRef.current.selectedStatusList = selectedStatusCode;
    selectedCallStatusHandler(()=>selectedStatusCode)

  };

  // Escalation active State handler

  const escalationActiveStatusHandler = (feedback, option) => {
    let aiEscalationActive = statusCodes?.aiEscalationActive;
    let selectedStatusCode = selectedStatusRef?.current.selectedStatusList;

    let idx = aiEscalationActive.findIndex(
      (item) => item.operator_feedback === feedback
    );
    let data = aiEscalationActive[idx];
    if (aiEscalationActive[idx].isChecked) {
      data = {
        ...data,
        isChecked: false,
      };
      selectedStatusCode = selectedStatusCode.filter(
        (statusCode) => statusCode != feedback
      );
    } else {
      data = {
        ...data,
        isChecked: true,
      };
      selectedStatusCode.push(feedback);
    }
    aiEscalationActive[idx] = data;
    setStatusCodes((prevState) => {
      return {
        ...prevState,
        aiEscalationActive: aiEscalationActive,
      };
    });
    selectedStatusRef.current.selectedStatusList = selectedStatusCode;
    selectedCallStatusHandler(()=>selectedStatusCode)

  };

  // Escalation unactive State handler

  const escalationUnActiveStatusHandler = (feedback, option) => {
    let aiEscalationUnActive = statusCodes?.aiEscalationUnActive;
    let selectedStatusCode = selectedStatusRef?.current.selectedStatusList;

    let idx = aiEscalationUnActive.findIndex(
      (item) => item.operator_feedback === feedback
    );
    let data = aiEscalationUnActive[idx];
    if (aiEscalationUnActive[idx].isChecked) {
      data = {
        ...data,
        isChecked: false,
      };
      selectedStatusCode = selectedStatusCode.filter(
        (statusCode) => statusCode != feedback
      );
    } else {
      data = {
        ...data,
        isChecked: true,
      };
      selectedStatusCode.push(feedback);
    }
    aiEscalationUnActive[idx] = data;
    setStatusCodes((prevState) => {
      return {
        ...prevState,
        aiEscalationUnActive: aiEscalationUnActive,
      };
    });
    selectedStatusRef.current.selectedStatusList = selectedStatusCode;
    selectedCallStatusHandler(()=>selectedStatusCode)

  };

  const selectAllSuccessFulStatus = () => {
    let aiSuccess = [];
    let userDisconnect = [];
    let escalation = [];
    statusCodes.successFulActive.forEach((item) => {
      if (successFullStatusCodeList.includes(item.operator_feedback)) {
        aiSuccess.push({
          ...item,
          isChecked: true,
        });
      } else {
        aiSuccess.push({
          ...item,
          isChecked: false,
        });
      }
    });

    statusCodes.userDisconnectActive.forEach((item) => {
      if (successFullStatusCodeList.includes(item.operator_feedback)) {
        userDisconnect.push({
          ...item,
          isChecked: true,
        });
      } else {
        userDisconnect.push({
          ...item,
          isChecked: false,
        });
      }
    });

    statusCodes.aiEscalationActive.forEach((item) => {
      if (successFullStatusCodeList.includes(item.operator_feedback)) {
        escalation.push({
          ...item,
          isChecked: true,
        });
      } else {
        escalation.push({
          ...item,
          isChecked: false,
        });
      }
    });

    setStatusCodes((prevState) => {
      return {
        ...prevState,
        successFulActive: aiSuccess,
        userDisconnectActive: userDisconnect,
        aiEscalationActive: escalation,
      };
    });
    selectedCallStatusHandler(()=>[...successFullStatusCodeList])
    selectedStatusRef.current.selectedStatusList = successFullStatusCodeList;
  };

  const unSelectSelectedStatus = (resetButtonClicked=false) => {
    let aiSuccess = [];
    let aiSuccessUnActive = [];

    let userDisconnect = [];
    let userDisconnectUnActive = [];

    let escalation = [];
    let escalationUnActive = [];

    statusCodes.successFulActive.forEach((item) => {
      aiSuccess.push({
        ...item,
        isChecked: false,
      });
    });
    statusCodes.successFulUnActive.forEach((item) => {
      aiSuccessUnActive.push({
        ...item,
        isChecked: false,
      });
    });

    statusCodes.userDisconnectActive.forEach((item) => {
      userDisconnect.push({
        ...item,
        isChecked: false,
      });
    });
    statusCodes.userDisconnectUnActive.forEach((item) => {
      userDisconnectUnActive.push({
        ...item,
        isChecked: false,
      });
    });

    statusCodes.aiEscalationActive.forEach((item) => {
      escalation.push({
        ...item,
        isChecked: false,
      });
    });
    statusCodes.aiEscalationUnActive.forEach((item) => {
      escalationUnActive.push({
        ...item,
        isChecked: false,
      });
    });
    setStatusCodes((prevState) => {
      return {
        ...prevState,
        successFulActive: aiSuccess,
        successFulUnActive: aiSuccessUnActive,
        userDisconnectActive: userDisconnect,
        userDisconnectUnActive: userDisconnectUnActive,
        aiEscalationActive: escalation,
        aiEscalationUnActive: escalationUnActive,
      };
    });
    if(!resetButtonClicked){

      
      selectedCallStatusHandler(()=>[])
    }

    if(resetButtonClicked==='UN_SELECT_STATUS'){
      selectedCallStatusHandler(()=>[])

    }
    selectedStatusRef.current.selectedStatusList = [];


  };
 // Unselecting the all status on "Reset"
 useEffect(()=>{

  if(Array.isArray(selectedCallStatus) && !selectedCallStatus.length && statusCodes.successFulActive.length ){
    unSelectSelectedStatus(true)
  }
},[selectedCallStatus])
  

  const closeModalHandler = () => {
    setShowCallStatus(!showCallStatus);
    closeModal();
  };
  return (
    <div
      className="modal-box"
      ref={(node) => (modalRef = node)}
      style={{ position: "relative" }}
    >
      <div className="callStatus">
        <div className="callstatus_AIcall" id="style_scroll">
          {
            <p style={{ marginLeft: "10px", marginBottom: "5px" }}>
              Active status
            </p>
          }
          {statusCodes?.successFulActive !== null &&
            statusCodes?.successFulActive.map((item) => {
              return (
                <ActiveStateContainer
                  key={item.operator_feedback_english}
                  // style={{
                  //   display: "flex",
                  //   justifyItems: "center",
                  //   marginBottom: "10px",
                  //   width: "250px",
                  // }}
                >
                  <ActiveStateInputContainer>
                    <div style={{ marginRight: "15px" }}>
                      <input
                        type="checkbox"
                        checked={item.isChecked}
                        // defaultChecked={showChecked(item.operator_feedback)}
                        value={item.operator_feedback}
                        className="callstatusChecbox"
                        style={{ marginLeft: "15px" }}
                        onChange={(event) =>
                          successFulStatusHandler(item.operator_feedback, item)
                        }
                        // onClick={()=> successFulStatusHandler(item.operator_feedback, item)}
                      />
                    </div>
                    <div style={{ color: "black" }}>
                      {item.operator_feedback_english}
                    </div>
                  </ActiveStateInputContainer>
                </ActiveStateContainer>
              );
            })}

          {statusCodes?.successFulUnActive !== null &&
            statusCodes?.successFulUnActive.length != 0 && (
              <hr
                style={{
                  border: "1px solid lightblack",
                  width: "100%",
                  // margin: "0px",
                  // color: "gray",
                }}
              ></hr>
            )}
        </div>
        <div className="callstatus_AIcall" id="style_scroll">
          {
            <p style={{ marginLeft: "10px", marginBottom: "5px" }}>
              Active status
            </p>
          }

          {statusCodes.userDisconnectActive !== null &&
            statusCodes.userDisconnectActive.map((item) => {
              return (
                <div
                  key={item.operator_feedback_english}
                  style={{
                    display: "flex",
                    justifyItems: "center",
                    marginBottom: "10px",
                    width: "250px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ marginRight: "15px" }}>
                      <input
                        type="checkbox"
                        checked={item.isChecked}
                        // defaultChecked={showChecked(item.operator_feedback)}
                        value={item.operator_feedback}
                        className="callstatusChecbox"
                        style={{ marginLeft: "15px" }}
                        onChange={(event) =>
                          userDisconnectStatusHandler(
                            item.operator_feedback,
                            item
                          )
                        }
                      />
                    </div>
                    <div style={{ color: "black" }}>
                      {item.operator_feedback_english}
                    </div>
                  </div>
                </div>
              );
            })}

          {statusCodes.userDisconnectUnActive !== null &&
            statusCodes.userDisconnectUnActive.length != 0 && (
              <hr
                style={{
                  border: "1px solid lightblack",
                  width: "100%",
                  // margin: "0px",
                  // color: "gray",
                }}
              ></hr>
            )}
        </div>
        <div className="callstatus_AIcall" id="style_scroll">
          {/*<div className="statusClose" onClick={closeModalHandler}>
            <CloseIcon />
          </div>*/}

          {
            <p style={{ marginLeft: "10px", marginBottom: "5px" }}>
              Active status
            </p>
          }
          {statusCodes.aiEscalationActive !== null &&
            statusCodes.aiEscalationActive.map((item) => {
              return (
                <div
                  key={item.operator_feedback_english}
                  style={{
                    display: "flex",
                    justifyItems: "center",
                    marginBottom: "10px",
                    width: "250px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ marginRight: "15px" }}>
                      <input
                        type="checkbox"
                        checked={item.isChecked}
                        // defaultChecked={showChecked(item.operator_feedback)}
                        value={item.operator_feedback}
                        className="callstatusChecbox"
                        style={{ marginLeft: "15px" }}
                        onChange={(event) =>
                          escalationActiveStatusHandler(
                            item.operator_feedback,
                            item
                          )
                        }
                      />
                    </div>
                    <div style={{ color: "black" }}>
                      {item.operator_feedback_english}
                    </div>
                  </div>
                </div>
              );
            })}
          {statusCodes.aiEscalationUnActive !== null &&
            statusCodes.aiEscalationUnActive.length != 0 && (
              <hr
                style={{
                  border: "1px solid lightblack",
                  width: "100%",
                  // margin: "0px",
                  // color: "gray",
                }}
              ></hr>
            )}
        </div>
      </div>

      <TextWrapper>
        <SuccessfulTextContainer onClick={selectAllSuccessFulStatus}>
          Successful Orders
        </SuccessfulTextContainer>
        <UnSelectText onClick={()=>unSelectSelectedStatus("UN_SELECT_STATUS")}>
          Unselect-All
        </UnSelectText>
      </TextWrapper>
      <div className="modalCloseBtn" onClick={closeModalHandler}>
        Done
      </div>
    </div>
  );
};

export default StatusCodeList;
